export default __webpack_public_path__ + "static/drukarki_dzierzawa_gx4040-ad1ca69d27237ac1c6a4abd5c39edb02.png";